var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnthusiastic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.022,
    height: 33.858,
    viewBox: "0 0 32.022 33.858",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enthusiastic",
    transform: "translate(-1.141 -305.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11654",
    "data-name": "Path 11654",
    d: "M12.646,108.563a4.209,4.209,0,1,0,2.976,1.233A4.209,4.209,0,0,0,12.646,108.563Z",
    transform: "translate(6.4 197.362)",
    fill: "#ef3f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11655",
    "data-name": "Path 11655",
    d: "M27.712,121.231a4.773,4.773,0,0,0-2.192-2.763,10.352,10.352,0,0,0-5.283-2.191c-8.768-.155-9.163.35-9.952-.461l-4.713-4.646a2.192,2.192,0,1,0-2.981,2.981l5.48,5.457c1.534,1.535,3.266.965,5.348,1.206v5.239a10.51,10.51,0,0,0-5.5,6.138l-1.754,5.983a2.436,2.436,0,1,0,4.691,1.315l1.534-5.7c.526-1.928,1.929-2.191,5.7-5.413a37.009,37.009,0,0,1,1.995,6.8l.7,4.077a2.456,2.456,0,0,0,4.844-.811l-.438-3.2a51.844,51.844,0,0,0-2.63-8.966v-4.514a2.189,2.189,0,0,1,1.381,1.381l1.578,5.216a2.192,2.192,0,0,0,4.055-1.2Z",
    transform: "translate(1.111 198.484)",
    fill: "#ef3f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11656",
    "data-name": "Path 11656",
    d: "M21.578,112.417l-1.754-.964L18.86,109.7a.569.569,0,0,0-.207-.2.574.574,0,0,0-.551,0,.567.567,0,0,0-.207.2l-.965,1.753-1.754.964a.535.535,0,0,0-.212.2.527.527,0,0,0-.073.283.5.5,0,0,0,.075.271.488.488,0,0,0,.209.188l1.754.966L17.9,116.1a.533.533,0,0,0,.2.209.526.526,0,0,0,.28.076.57.57,0,0,0,.482-.285l.964-1.774,1.754-.966a.488.488,0,0,0,.209-.188.5.5,0,0,0,.076-.271.531.531,0,0,0-.073-.283A.536.536,0,0,0,21.578,112.417Z",
    transform: "translate(11.299 198.023)",
    fill: "#ef3f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11657",
    "data-name": "Path 11657",
    d: "M7.619,119.93a.566.566,0,0,0-.079-.278.573.573,0,0,0-.206-.2l-1.754-.966-.964-1.753a.57.57,0,0,0-.964,0l-.964,1.753-1.754.966a.573.573,0,0,0-.206.2.566.566,0,0,0-.079.278.549.549,0,0,0,.285.482l1.754.966.964,1.753a.554.554,0,0,0,.482.285.575.575,0,0,0,.279-.079.583.583,0,0,0,.2-.206l.964-1.753,1.754-.966a.549.549,0,0,0,.285-.482Z",
    transform: "translate(0.492 203.356)",
    fill: "#ef3f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11658",
    "data-name": "Path 11658",
    d: "M6.232,111.44h.416a.568.568,0,0,0,.513-.765.545.545,0,0,0-.117-.185.572.572,0,0,0-.181-.125.563.563,0,0,0-.215-.044H6.232a.548.548,0,1,0,0,1.1Z",
    transform: "translate(4.313 198.696)",
    fill: "#ef3f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11659",
    "data-name": "Path 11659",
    d: "M2.343,109.611a.547.547,0,0,0-.548-.549h-.46a.548.548,0,1,0,0,1.1H1.8a.547.547,0,0,0,.548-.547Z",
    transform: "translate(0.598 197.741)",
    fill: "#ef3f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11660",
    "data-name": "Path 11660",
    d: "M6.575,119.668a.547.547,0,0,0,.548-.549.568.568,0,0,0-.548-.547H6.093a.548.548,0,1,0,0,1.1Z",
    transform: "translate(4.207 204.956)",
    fill: "#ef3f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11661",
    "data-name": "Path 11661",
    d: "M1.2,114.621a.548.548,0,1,0,0,1.1h.5a.548.548,0,1,0,0-1.1Z",
    transform: "translate(0.492 201.958)",
    fill: "#ef3f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11662",
    "data-name": "Path 11662",
    d: "M15.192,110.183h.482a.548.548,0,1,0,0-1.1h-.482a.548.548,0,1,0,0,1.1Z",
    transform: "translate(11.109 197.76)",
    fill: "#ef3f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11663",
    "data-name": "Path 11663",
    d: "M18.854,114.2h-.46a.506.506,0,0,0-.241.005.547.547,0,0,0,0,1.062.506.506,0,0,0,.241.005h.46a.506.506,0,0,0,.241-.005.547.547,0,0,0,0-1.062A.506.506,0,0,0,18.854,114.2Z",
    transform: "translate(13.455 201.632)",
    fill: "#ef3f4e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnthusiastic);
export default __webpack_public_path__ + "static/media/enthusiastic.2ed3a1f45c84b3b7fd32e53f1e946472.svg";
export { ForwardRef as ReactComponent };